var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSadEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 122.9 122.9"
    },
    viewBox: "0 0 122.9 122.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill-rule:evenodd;clip-rule:evenodd;fill:#141518}")), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 2c32.8-8.8 66.5 10.7 75.3 43.5s-10.7 66.5-43.5 75.3C44.6 129.6 10.8 110.2 2 77.4-6.7 44.6 12.7 10.8 45.5 2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fbd433"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 32.2c4.3 0 7.8 5 7.8 11.3s-3.5 11.3-7.8 11.3-7.8-5-7.8-11.3 3.5-11.3 7.8-11.3zM77.1 32.2c4.3 0 7.8 5 7.8 11.3s-3.5 11.3-7.8 11.3-7.8-5-7.8-11.3 3.5-11.3 7.8-11.3z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1 94.9c-2.5-3.2-5.5-6.1-8.8-8.4-7.4-5.1-16.1-7.7-25-7.5-8.7 0-17.2 2.9-24.1 8.1-2.9 2.2-5.4 4.9-7.5 7.9-.1.1-.2.1-.3 0l-2.5-2.4c-.1-.1-.1-.2 0-.3C29.4 86.2 34.2 81 40 77.1c5.9-4 12.9-6.2 20.1-6.4 7.3-.1 14.5 1.8 20.7 5.6 6.6 4 12.1 9.4 16.3 15.9.1.1.1.2 0 .3L94.5 95c-.1 0-.2 0-.4-.1.1.1.1.1 0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSadEmoji);
export default __webpack_public_path__ + "static/media/ic_sad_emoji.030641e509c03e2d858b20e40d36a14c.svg";
export { ForwardRef as ReactComponent };